
import {
  defineComponent, ref, onMounted, computed, inject,
} from 'vue';
import { useMainStore } from '@/store/mainStore';
import MessageSharingPopUp from '@/components/BottomPopUp/PopUpTypes/Settings/MessageSharingPopUp.vue';
import { SHARE_SETTINGS } from '@/types/enums';

export default defineComponent({
  emits: ['update-settings'],
  props: {
    shareSettings: { type: Array as () => SHARE_SETTINGS[] },
  },
  components: {
    MessageSharingPopUp,
  },
  setup(props, { emit }) {
    const mainStore = useMainStore();
    // eslint-disable-next-line @typescript-eslint/ban-types
    const $localize = inject('$localize') as Function;

    // const selectedSettings = ref({
    //   allowedResharing: mainStore.sharingSettings[0].allowedResharing,
    //   allowedSave: mainStore.sharingSettings[0].allowedSave,
    //   allowedDisplay: mainStore.sharingSettings[0].allowedDisplay,
    // });

    // const dummyResharing = computed(() => !sharingSettings.value.allowedResharing);
    // function dummyResharingValueChange(e) {
    //   sharingSettings.value.allowedResharing = !e.target.checked;
    // }
    //
    // const dummySave = computed(() => !sharingSettings.value.allowedSave);

    // function dummySaveValueChange(e) {
    //   sharingSettings.value.allowedSave = !e.target.checked;
    // }

    const showSettings = ref(false);
    const sharingSettings = ref({
      allowedResharing: props.shareSettings?.includes(SHARE_SETTINGS.RESHARE_ALLOWED) || false,
      allowedSave: props.shareSettings?.includes(SHARE_SETTINGS.ALLOW_SAVE) || false,
      allowedDisplay: props.shareSettings?.includes(SHARE_SETTINGS.DISPLAY_ATTRIBUTION) || false,
    });
    const allowedResharedValue = computed(() => (props.shareSettings?.includes(SHARE_SETTINGS.RESHARE_ALLOWED)
      ? $localize('share.by.message.bar.allow.sharing')
      : $localize('share.by.message.bar.not.allow.sharing')));
    const allowedSavingValue = computed(() => (props.shareSettings?.includes(SHARE_SETTINGS.ALLOW_SAVE)
      ? $localize('share.by.message.bar.allow.saving')
      : $localize('share.by.message.bar.not.allow.saving')));

    function updateSettings(shareOpt) {
      emit('update-settings', shareOpt);
    }
    // onMounted(() => {
    //   emit('update-settings', sharingSettings.value);
    // });

    return {
      allowedResharedValue,
      allowedSavingValue,
      // dummySave,
      // dummySaveValueChange,
      //
      // dummyResharing,
      // dummyResharingValueChange,
      showSettings,
      sharingSettings,
      // arrayOfValues,
      updateSettings,
    };
  },
});
